import Chart, { ChartWrapperOptions } from 'react-google-charts'

import { SkeletonDots } from '@yes.technology/react-toolkit'
import { useMemo, useState } from 'react'
import { StyledGoogleChart, Title } from '../Cockpit.styles'
import { ChartWrapperProps } from '../Cockpit.types'
import { ComboChartData } from './BurnChart/BurnChart.types'

export const DEFAULT_CHART_HEIGHT = 400

type GoogleChartProps = Omit<ChartWrapperProps, 'data'> & {
  data: ChartWrapperProps['data'] | ComboChartData
  hideTitle?: boolean
}

const GoogleChart = ({
  chartModel,
  data,
  options,
  chartUuid,
  title,
  chartLanguage = 'pt',
  chartEvents,
  hideTitle
}: GoogleChartProps) => {
  const [loaded, setLoaded] = useState(false)

  const handleLoad = () => {
    setLoaded(true)
  }

  const events = useMemo(() => {
    const allEvents = chartEvents ?? []

    const isSelectEventIncluded = allEvents.some(
      (event: ChartWrapperOptions['chartEvents']) =>
        event.eventName === 'select'
    )

    if (!isSelectEventIncluded) {
      return [
        ...allEvents,
        {
          eventName: 'select',
          callback: () => ({})
        }
      ]
    }

    return chartEvents
  }, [chartEvents])

  return (
    <StyledGoogleChart {...{ chartModel }}>
      {loaded && !hideTitle && <Title>{title}</Title>}
      <Chart
        chartType={chartModel}
        width={'100%'}
        height={DEFAULT_CHART_HEIGHT}
        legendToggle
        data={data}
        options={options}
        mapsApiKey={window.googleCloudApikey}
        graphID={chartUuid}
        loader={<SkeletonDots />}
        onLoad={handleLoad}
        aria-label={title}
        chartLanguage={chartLanguage}
        chartEvents={events}
        style={{
          userSelect: 'none'
        }}
      />
    </StyledGoogleChart>
  )
}

export default GoogleChart
